import { FileSearch } from "lucide-react";

import { cn, getFileExtension } from "@/modern/utils";

import { useFileDetailModal } from "../../context/FileDetailModalContext";

interface SearchTextLinkProps {
  searchText: string;
  className?: string;
}

/**
 * Clickable link that navigates the PDF viewer to the source text.
 * Triggers a text search in the rendered PDF text layer, scrolls to
 * the first match, and applies a temporary highlight.
 */
export const SearchTextLink = ({ searchText, className }: SearchTextLinkProps) => {
  const { handleSearchInPdf, file } = useFileDetailModal();

  const isPDF = file?.name ? getFileExtension(file.name) === "pdf" : false;

  if (!searchText || !isPDF) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleSearchInPdf(searchText);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title={`Find in document: "${searchText.length > 80 ? searchText.slice(0, 80) + "..." : searchText}"`}
      className={cn(
        "inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-primary transition-colors",
        className
      )}
    >
      <FileSearch className="w-3 h-3 shrink-0" />
      <span className="truncate max-w-[150px]">Find in document</span>
    </button>
  );
};
